// Settings Panel - Unified settings UI across all pages

export const SettingsPanel = {
    initialized: false,

    async init() {
        if (this.initialized) return;
        this.injectHTML();
        await this.initToggles();
        this.bindEvents();
        this.initialized = true;
    },

    injectHTML() {
        const html = `
            <button class="settings-btn" id="settings-btn" aria-label="Settings">&#9881;</button>
            <div class="settings-modal" id="settings-modal">
                <div class="settings-content">
                    <h3>SETTINGS</h3>
                    <div class="settings-row">
                        <span class="settings-label">Theme</span>
                        <div class="theme-toggle" id="theme-toggle-container"></div>
                    </div>
                    <div class="settings-row">
                        <span class="settings-label">Ship Style</span>
                        <div id="ship-style-container"></div>
                    </div>
                    <button class="btn settings-close" id="settings-close">CLOSE</button>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);
    },

    async initToggles() {
        // Theme toggle - ThemeManager should be globally available
        const themeContainer = document.getElementById('theme-toggle-container');
        if (themeContainer && window.ThemeManager) {
            window.ThemeManager.createToggle(themeContainer);
        }

        // Ship style toggle - dynamically import if not available
        const shipContainer = document.getElementById('ship-style-container');
        if (shipContainer) {
            let shipGraphics = window.shipGraphicsManager;
            if (!shipGraphics) {
                try {
                    const module = await import('/djbship/js/shipGraphics.js');
                    shipGraphics = module.shipGraphicsManager;
                    // Preload SVGs for when user plays game later
                    shipGraphics.preloadSVGs();
                } catch (err) {
                    console.warn('[SettingsPanel] Could not load shipGraphics:', err);
                }
            }
            if (shipGraphics) {
                shipGraphics.createToggle(shipContainer);
            }
        }
    },

    bindEvents() {
        const btn = document.getElementById('settings-btn');
        const modal = document.getElementById('settings-modal');
        const close = document.getElementById('settings-close');

        if (btn && modal) {
            btn.addEventListener('click', () => modal.classList.add('visible'));
        }

        if (close && modal) {
            close.addEventListener('click', () => modal.classList.remove('visible'));
        }

        if (modal) {
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    modal.classList.remove('visible');
                }
            });
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal && modal.classList.contains('visible')) {
                modal.classList.remove('visible');
            }
        });
    }
};
